function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeTFukushidoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.46,67.63c9.74,16.87,31.31,22.65,48.17,12.91,16.87-9.74,22.65-31.31,12.91-48.17-9.74-16.86-31.3-22.64-48.17-12.9-16.86,9.74-22.64,31.3-12.91,48.17ZM73.96,36.16c7.64,13.24,3.11,30.16-10.13,37.8-13.23,7.64-30.15,3.1-37.8-10.13-7.64-13.23-3.1-30.15,10.13-37.79s30.16-3.11,37.8,10.12Z",
    style: {
      fill: "#000",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.92,36.2c-1.66-1.15-4.57-1.09-5.47,1.26-6.03,15.7-15.81,27.64-25.99,36.08l5.22,5.22c9.37-7.83,19.12-19.34,26.9-37.67.68-1.6,1.09-3.68-.65-4.88Z",
    style: {
      fill: "#000",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.08,36.2c1.66-1.15,4.57-1.09,5.47,1.26,6.03,15.7,15.81,27.64,25.99,36.08l-5.22,5.22c-9.37-7.83-19.12-19.34-26.9-37.67-.68-1.6-1.09-3.68.65-4.88Z",
    style: {
      fill: "#000",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeTFukushidoin);
export default __webpack_public_path__ + "static/media/acae_t_fukushidoin.0079d635.svg";
export { ForwardRef as ReactComponent };